import React from "react";
import { CheckCircle2, XCircle, X } from "lucide-react";

export type ToastType = "success" | "error";

export interface ToastItem {
  id: string;
  type: ToastType;
  title: string;
  message: string;
}

interface ToastProps {
  toast: ToastItem;
  onClose: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({ toast, onClose }) => {
  const isSuccess = toast.type === "success";

  return (
    <div
      className={`w-full rounded-xl border bg-white p-4 shadow-lg ${
        isSuccess ? "border-green-200" : "border-red-200"
      }`}
    >
      <div className="flex items-start gap-3">
        <div
          className={`mt-0.5 ${isSuccess ? "text-green-600" : "text-red-600"}`}
        >
          {isSuccess ? <CheckCircle2 size={20} /> : <XCircle size={20} />}
        </div>

        <div className="min-w-0 flex-1">
          <p
            className={`text-sm font-semibold ${
              isSuccess ? "text-green-700" : "text-red-700"
            }`}
          >
            {toast.title}
          </p>

          <p className="mt-1 text-xs text-slate-600">{toast.message}</p>
        </div>

        <button
          type="button"
          onClick={() => onClose(toast.id)}
          className="text-slate-400 transition hover:text-slate-600"
          aria-label="Close notification"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default Toast;
